import { http } from '../../core/services'

const generateMenuMetricsReport = sessionId =>
  http.get(`/reports/menu-metrics/${sessionId}`, { responseType: 'blob' })

export default generateMenuMetricsReport
